import { AfterViewInit, ViewChild, Output, EventEmitter } from '@angular/core';

export class Picker implements AfterViewInit {
    @ViewChild('dropdownInput') dropdownInput;
    @Output() closeDropDown = new EventEmitter();

    ngAfterViewInit() {
        this.dropdownInput.nativeElement.focus();
    }
}
